<template>
    <v-dialog
      persistent
      value="true"
      max-width="500"
      @keydown.esc="handleCancel"
      @input="v => handleCancel()"
    >
      <v-card>
        <v-card-title class="headline">{{doc.name}}</v-card-title>
        <v-card-text v-if="doc.description">{{ doc.description }}</v-card-text>
      <DataForm
        :fields="doc.fields"
        :form="form"
        :updateField="updateFormField"
      />
          <v-card-actions>
           <v-btn flat="flat" @click.native.stop="handleCancel">Annuler</v-btn>
           <v-spacer></v-spacer>
           <v-btn @click.native.stop="handleConfirm">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import DataForm from '@/components/form/DataForm'
import { newFromPayload } from '@/utils'
export default {
  components: {
    DataForm,
  },
  data: () => ({
    form: {
      dialog: false,
      data: {},
      hasError: false,
      errors: {},
      saved: false,
      showAlert: false,
    },
  }),
  computed: {},
  props: {
    doc: Object,
  },
  methods: {
    handleConfirm () {
      this.$close(this.form.data)
    },
    handleCancel () {
      this.$error('cancelled')
    },
    updateFormField (payload) {
      this.form.data = newFromPayload(this.form.data, payload)
    },
  },
}
</script>

<style>

</style>
